'use strict';

export default class DashboardNavigationByRole {
  constructor() { 
    this.name = 'dashboard-navigation-by-role';
    self = this;
    var navigation = $("#block-system-menu-block-member-navigation");
    
    if(navigation.length < 1) return;
    
    var roles = $("#block-views-block-user-identification-block-1 .views-field-roles-target-id .field-content .item-list li .role");
    var rolesArr = [];
    roles = roles.map(function(k, v) {
      rolesArr.push($(v).data('role'));
    });

    if(rolesArr.includes("Administrator")) {
      navigation.find(`li`).show();
    }
    
    rolesArr.forEach(role => {
      if(role == "Volunteer") navigation.find(`li[data-visible-for-roles*=volunteers]`).show();
      if(role == "Personal Member") navigation.find(`li[data-visible-for-roles*=members]`).show();
      if(role == "Prospect") navigation.find(`li[data-visible-for-roles*=prospect]`).show();
    });

    navigation.find(".menu.menu-level-0").show();
  }
}
